import { useEffect, useState } from "react";
import glassSandImage from "@/assets/images/predictions/glass_sand.jpeg";
import mascotImage from "@/assets/images/predictions/mascot.png";
import { useActiveCompetition } from "@/features/predictions/hooks/useActiveCompetition";
import {
  formatCountdown,
  formatDateRange,
  getCountdownParts,
} from "@/features/predictions/utils/timezone";

const useTick = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const interval = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(interval);
  }, []);
  return now;
};

export const PredictionsHero = () => {
  const { data: competition } = useActiveCompetition();
  const now = useTick();

  const title = competition?.name ?? "Pronostics";

  const subtitle = (() => {
    if (!competition) {
      return "Pronostiquez les matchs entre collègues et grimpez au classement.";
    }
    const datesRange = formatDateRange(competition.startsAt, competition.endsAt);
    const startsParts = getCountdownParts(competition.startsAt, now);
    if (!startsParts.hasReachedZero) {
      return `${datesRange} — commence dans ${formatCountdown(startsParts)}.`;
    }
    const endsParts = getCountdownParts(competition.endsAt, now);
    if (!endsParts.hasReachedZero) {
      return `${datesRange} — se termine dans ${formatCountdown(endsParts)}.`;
    }
    return `${datesRange} — tournoi terminé.`;
  })();

  return (
    <section
      className="relative overflow-hidden rounded-lg bg-gray-900 px-6 pt-8 pb-8 text-white md:px-10 md:pt-10 md:pb-10"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute -inset-4 bg-cover bg-center bg-no-repeat blur-[2px]"
        style={{ backgroundImage: `url(${glassSandImage})` }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"
      />
      <div className="relative space-y-3">
        <h1 className="text-3xl font-bold tracking-tight md:text-4xl">
          {title}
        </h1>
        <p className="max-w-2xl text-sm text-white/80 md:text-base">
          {subtitle}
        </p>
      </div>
      <img
        src={mascotImage}
        alt=""
        aria-hidden
        className="pointer-events-none absolute -bottom-16 right-4 h-44 select-none drop-shadow-2xl md:-bottom-24 md:right-8 md:h-60"
      />
    </section>
  );
};

PredictionsHero.displayName = "PredictionsHero";
